import { handleResponse, handleError } from "./apiUtils";
import { config } from "../tools/config";
const baseUrl = config.env.REACT_APP_API_ROOT;

export function getApiStatus() {
  // No auth header needed for the health API; we call this while not logged in.
  return fetch(`${baseUrl}/health`).then(handleResponse).catch(handleError);
}
